import type { FC, ReactNode } from "react";

interface NavigationIconProps {
  svgBody: ReactNode;
  className?: string;
  size?: number;
}

export const NavigationIcon: FC<NavigationIconProps> = ({
  svgBody,
  className,
  size = 24,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      {svgBody}
    </svg>
  );
};
